import * as React from "react";
// import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"

function SvgDownloadIcon(props) {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="11.5" height="11.5" viewBox="0 0 11.5 11.5"><defs></defs>
      <g transform="translate(-4 -4)">
      <path className="a" fill="none" stroke={props.color|| "#0072c6"} strokeLinecap="round" strokeLinejoin="round" d="M15,22.5v2.333A1.167,1.167,0,0,1,13.833,26H5.667A1.167,1.167,0,0,1,4.5,24.833V22.5" transform="translate(0 -11)"/>
      <path className="a" fill="none" stroke={props.color|| "#0072c6"} strokeLinecap="round" strokeLinejoin="round" d="M10.5,15l2.917,2.917L16.333,15" transform="translate(-3.667 -6.417)"/>
      <path className="a" fill="none" stroke={props.color|| "#0072c6"} strokeLinecap="round" strokeLinejoin="round" d="M18,11.5v-7" transform="translate(-8.25)"/>
      </g>
      </svg>
      );
}

export default SvgDownloadIcon;